import { startOfDay } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';

export function getAmenityImageLink(imgSrc: string) {
  return imgSrc ? `${process.env.REACT_APP_ASSETS_URL}/chitown-building/${imgSrc.split('/').pop()}` : '';
}

export function getStartOfDayInTimezone(timezone = 'America/Chicago') {
  return fromZonedTime(startOfDay(toZonedTime(new Date(), timezone)), timezone).getTime();
}

const formatMinutesToTime = (timeInMinutes: number): string => {
  const hours = Math.floor(timeInMinutes / 60);
  const minutes = timeInMinutes % 60;
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;

  return `${displayHours}${minutes > 0 ? `:${minutes}` : ':00'} ${period}`;
};

export const formatTimeRange = (startTime: number, endTime: number): string =>
  `${formatMinutesToTime(startTime)}-${formatMinutesToTime(endTime)}`;
